import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import "../../styles/PatientView.css";

const InfoDisplay = ({ availableDoctors }) => {
  const { t } = useTranslation(); 

  return (
    <div className="info-display-container">
      {/* Section 1 - Timeline */}
      <div className="vertical-timeline-container">
        <h2>{t("patient_view_info.steps_to_schedule")}</h2>
        <div className="vertical-timeline">
          <div className="timeline-step">
            <div className="timeline-marker">1</div>
            <div className="timeline-content">
              <h4 className="timeline-step-title">{t("patient_view_info.search_select_clinic")}</h4>
              <p className="timeline-step-description">{t("patient_view_info.search_select_clinic_desc")}</p>
            </div>
          </div>

          <div className="timeline-step">
            <div className="timeline-marker">2</div>
            <div className="timeline-content">
              <h4 className="timeline-step-title">{t("patient_view_info.choose_discipline")}</h4>
              <p className="timeline-step-description">{t("patient_view_info.choose_discipline_desc")}</p>
            </div>
          </div>

          <div className="timeline-step">
            <div className="timeline-marker">3</div>
            <div className="timeline-content">
              <h4 className="timeline-step-title">{t("patient_view_info.pick_practitioner_time")}</h4>
              <p className="timeline-step-description">{t("patient_view_info.pick_practitioner_time_desc")}</p>
            </div>
          </div>

          <div className="timeline-step">
            <div className="timeline-marker">4</div>
            <div className="timeline-content">
              <h4 className="timeline-step-title">{t("patient_view_info.confirm_booking")}</h4>
              <p className="timeline-step-description">{t("patient_view_info.confirm_booking_desc")}</p>
            </div>
          </div>
        </div>
      </div>

      {/* Section 2 - Dynamic Practitioner List */}
      <div className="info-practitioner-list">
        <h3 className="info-practitioner-title">{t("patient_view_info.available_practitioners")}</h3>
        {availableDoctors.length > 0 ? (
          <div className="info-practitioner-cards scrollable-container">
            {availableDoctors.map((doctor) => (
              <div key={doctor.id} className="info-practitioner-card">
                <img
                  src={doctor.image || "/images/default.jpeg"}
                  alt={`${doctor.firstName} ${doctor.lastName}`}
                  className="info-practitioner-image"
                />
                <div className="info-practitioner-details">
                  <div className="info-practitioner-header">
                    <h4 className="info-practitioner-name">
                      {doctor.firstName} {doctor.lastName}
                    </h4>
                    <p className="info-practitioner-phone">{doctor.phone}</p>
                  </div>

                  <div className="info-practitioner-row">
                    <p className="info-practitioner-specialization">
                      {doctor.specialization || doctor.discipline}
                    </p>
                    <p className="info-practitioner-license">{doctor.licenseNumber}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p className="info-default-message">{t("patient_view_info.select_discipline_to_view")}</p>
        )}
      </div>
    </div>
  );
};

// Define PropTypes for the component
InfoDisplay.propTypes = {
  availableDoctors: PropTypes.array.isRequired, // Pass availableDoctors as a prop
};

export default InfoDisplay;
